import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: ""
  });

  const handleLogin = async () => {

    const res = await fetch(
      "https://brightlifephysio.com/api/login.php",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      }
    );

    const data = await res.json();

    if (data.status === "success") {

      navigate("/admin");

    } else {

      alert("Invalid credentials");

    }
  };

  return (
    <div style={styles.page}>

      <div style={styles.card}>

        <h2>BrightLife Admin</h2>

        <input
          placeholder="Username"
          style={styles.input}
          onChange={(e) =>
            setForm({
              ...form,
              username: e.target.value
            })
          }
        />

        <input
          type="password"
          placeholder="Password"
          style={styles.input}
          onChange={(e) =>
            setForm({
              ...form,
              password: e.target.value
            })
          }
        />

        <button
          style={styles.button}
          onClick={handleLogin}
        >
          Login
        </button>

      </div>

    </div>
  );
}

const styles = {

  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f7f9"
  },

  card: {
    background: "#fff",
    padding: 30,
    borderRadius: 12,
    width: 320,
    boxShadow: "0 3px 12px rgba(0,0,0,0.1)"
  },

  input: {
    width: "100%",
    padding: 10,
    marginBottom: 15,
    borderRadius: 6,
    border: "1px solid #ccc"
  },

  button: {
    width: "100%",
    background: "#0F6E56",
    color: "#fff",
    border: "none",
    padding: 12,
    borderRadius: 6,
    cursor: "pointer"
  }
};